/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLayoutCollage = createReactComponent("layout-collage", "IconLayoutCollage", [
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-0"
    }
  ],
  ["path", { d: "M10 4l4 16", key: "svg-1" }],
  ["path", { d: "M12 12l-8 2", key: "svg-2" }]
]);

export { IconLayoutCollage as default };
//# sourceMappingURL=IconLayoutCollage.js.map
